import React, { useState, useEffect } from "react";
import { Cabins } from "../../../helpers/Cabins";
import { BiChevronLeft, BiChevronRight } from "react-icons/bi";
import { BsCheck, BsCheckAll } from "react-icons/bs";
import { HiChevronDown } from "react-icons/hi";
import { MdLocationOn } from "react-icons/md";
import { Colors } from "../../../helpers/Colors";
import { fontSize } from "../../../helpers/fontSize";
import { makeStyles } from "@mui/styles";
import tomImg from "../../../assets/images/cabins/tom.jpg";
import DyootiLogo from "../../../assets/images/logo/Fav_icon.svg";
import toast from "react-hot-toast";
import axios from "axios";
import { IoClose } from "react-icons/io5";
import { Modal_useStyles } from "../../../useStyles/Modal_useStyles";
import { Resolution } from "../../../helpers/Resolution";
import { ax_getCabins } from "../../../api/cabin";

const useStyles = makeStyles({
  Cabins: {
    display: "flex",
    // alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",

    height: "full",
    // backgroundColor: Colors.primary,
    fontSize: fontSize.question,
    cursor: "pointer",
    // --------- from xs(380px) till md(770px)
    "@media only screen and (max-Width: 770px)": {
      padding: "5px 10px",
      // backgroundColor: Colors.error,
    },
    // --------- from md(770px) till xl(1200px)
    "@media (min-width: 770px) and (max-width: 1200px)": {
      padding: "10px 40px",
      // backgroundColor: "purple",
    },
    // --------- from xl(1200px) to above screen
    "@media only screen and (min-width: 1200px)": {
      padding: "10px 120px",
      // backgroundColor: "cyan",
    },
    "& .Header": {
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
      fontWeight: 600,
      boxShadow: `0px 3px 10px ${Colors.primaryMedium}`,
      "& .number": {
        width: "auto",
        height: "auto",
        padding: "8px 15px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: Colors.primary,
        // borderRadius: "20px",
        // --------- from xs(380px) till md(770px)
        "@media only screen and (max-Width: 770px)": {
          padding: "6.5px 15px",
        },
      },
      "& .question_chevron": {
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        backgroundColor: Colors.white,
        padding: "0px 15px",
        // --------- from xs(380px) till md(770px)
        "@media only screen and (max-Width: 770px)": {
          padding: "0px 5px",
        },
        // // --------- from md(770px) till xl(1200px)
        // "@media (min-width: 770px) and (max-width: 1200px)": {
        //   padding: "10px 40px",
        //   backgroundColor: Colors.secondary,
        // },
        // // --------- from xl(1200px) to above screen
        // "@media only screen and (min-width: 1200px)": {
        //   padding: "10px 120px",
        //   backgroundColor: Colors.logo8,
        // },
        "& .question": {
          padding: "8px",
          // --------- from xs(380px) till md(770px)
          "@media only screen and (max-Width: 770px)": {
            padding: "8px 5px",
            fontSize: fontSize.modalInput,
          },
        },
        "& .rightCon": {
          display: "flex",
          padding: "8px 0px 8px 8px",
          "& .selected": {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: 500,
            fontSize: fontSize.selected,
            color: Colors.grey,
            "& span": {
              margin: "0px 5px",
              // color: (props) => props.cabinName === Cabins.cabin1 ? `${Colors.tom}` :  `${Colors.jerry}`,
            },
          },
          "& .iconCon": {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            // cursor: "pointer",
            "& .icon": {
              width: "25px",
              height: "25px",
            },
          },
        },
      },
    },
  },
  Body: {
    // display: "flex",
    // alignItems: "center",
    // justifyContent: "center",
    maxHeight: "60vh",
    // height: "fit-content",
    // overflow: "scroll",

    /* Hide scrollbar for Chrome, Safari and Opera */

    "&::-webkit-scrollbar": {
      width: "8px",
      height: "20px",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: Colors.greyScrollBar,
      opacity: 0.2,
      borderRadius: "100vh",
      padding: "4px",
    },
    "&::-webkit-scrollbar-thumb": {
      width: "8px",
      backgroundColor: Colors.primary,
      borderRadius: "100vh",
      "&:hover": {
        backgroundColor: Colors.greyDark,
      },
    },
    "& .BodyCon": {
      maxHeight: "50vh",
      // display: "grid",
      // gridTemplateColumns: "422px 422px",
      // gridGap: "20px",
      // display: "flex",
      // alignContent: "center",
      // justifyContent: "flex-start",
      // flexWrap: "wrap",
      padding: "10px 20px",
      "@media only screen and (max-Width:430px)": {
        padding: "5px 10px 5px 0",
      },
    },
  },
  CheckIconCon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    // cursor: "pointer",
    border: `2px solid ${Colors.success}`,
    borderRadius: "20px",
    color: Colors.success,
    margin: "0 5px 0 0",
    "& .icon": {
      width: "20px",
      height: "20px",
    },
  },
  EmptyCheckIconCon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: `2px solid ${Colors.grey}`,
    borderRadius: "20px",
    color: Colors.grey,
    margin: "0 5px 0 0",
    "& .emptyIcon": {
      // display: "none",
      visibility: "hidden",
      width: "20px",
      height: "20px",
    },
  },
  Label: {
    width: "fit-content",
  },
  cabin1: {
    color: Colors.tom,
  },
  cabin2: {
    color: Colors.spike,
  },
  cabin3: {
    color: Colors.tyke,
  },
  cabin4: {
    color: Colors.jerry,
  },
  Cabin_1: {
    width: "100%",
    height: "60px",
    display: "flex",
    flexDirection: "row",
    alignContent: "center",
    justifyContent: "space-between",
    backgroundColor: Colors.primaryExtraLight2,
    border: `1px solid ${Colors.secondary}`,
    padding: "10px",
    borderRadius: "10px",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: Colors.primaryLight,
      color: Colors.secondary,
      boxShadow: `${Colors.primaryMedium} 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px`,
      "& span": {
        // color: Colors.white,
      },
      "& .location": {
        color: Colors.secondary,
      },
    },
    "@media only screen and (max-Width:430px)": {
      padding: "5px 10px",
    },
    // "& span": {
    //   margin: "0 5px 0 0",
    //   color: Colors.grey,
    //   fontWeight: 400,
    // },
    "& .Row1": {
      display: "flex",
      "& .img": {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "45px",
        height: "40px",
        borderRadius: "50px",
        border: `1px solid ${Colors.secondary}`,
        "@media only screen and (max-Width:430px)": {
          margin: "4px 0 0 0",
          width: "50px",
        },
        "& img": {
          borderRadius: "50px",
        },
      },
      "& .Name_SeatingCapacity": {
        padding: "10px 0 10px 20px",
        display: "flex",
        width: "100%",
        justifyContent: "space-between",
        flexDirection: "row",
        //  flex flex-row items-center justify-start
        "@media only screen and (max-Width:430px)": {
          flexDirection: "column",
          padding: "0px 0 0px 10px",
        },
        // "@media only screen and (min-Width:1200px)": {
        //   // margin: "0px 15px",
        //   "&:hover .dropdownCon": {
        //     display: "block",
        //   },
        // },
        "& .name": {
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          width: "130px",
          fontWeight: 500,
          padding: "0px 0px 0 0",
        },
        "& .seatingCapacity": {
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          width: "140px",
          padding: "0px 0 0 10px",
          fontWeight: 500,
          "@media only screen and (max-Width:430px)": {
            padding: "0px 0 0 0px",
            marginTop: "-3px",
          },
          "& span": {
            fontSize: fontSize.label,
            color: Colors.greySteel,
            margin: "0 5px 0 0",
          },
        },
      },
    },
    "& .Row2": {
      display: "flex",
      // flexDirection: "column",
      alignItems: "center",
      justifyContent: "flex-end",
      // flexGrow: "1",
      // padding: "10px 20px",
      "& span": {
        fontWeight: 500,
        fontSize: fontSize.label,
        margin: "0 0 0 3px",
      },
      "& .location": {
        color: Colors.greySteel,
      },
      "& .locationIcon": {
        color: Colors.locationRed,
        // background: "linear-gradient(to right bottom, #430089, #82ffa1)",
        // WebkitBackgroundClip: "text",
        // WebkitTextFillColor: "transparent",
      },
    },
  },
  Cabin_1_input: {
    display: "none",
  },
});

const CabinComponent = ({
  cabinName,
  setCabinName,
  onChangeHandler,
  // slideNextToDate,
  selectCabinPlease,
  triggerUseEffect,
  setUseEffect,
}) => {
  const classes = useStyles();
  const Modal_Classes = Modal_useStyles();
  // const [showCabinContent, setShowCabinContent] = useState(false);
  const [rotateCabinChevron, setRotateCabinChevron] = useState(false);
  const [allCabins, setAllCabins] = useState([]);
  const [showCabins, setShowCabins] = useState(false);

  const rotateCabinChev = rotateCabinChevron
    ? "rotate(180deg)"
    : "rotate(0deg)";

  const onCabinHeaderClick = () => {
    // setShowCabinContent(!showCabinContent);
    setShowCabins(!showCabins);
    // setRotateCabinChevron(!rotateCabinChevron);
  };

  const onSelectCabin = () => {
    setShowCabins(false);
    setUseEffect(true);
    // sliderRef.current.slickNext();
    // dispatch(reservation_details({ cabinName }));
    toast("Now, Select Date & Time!", {
      icon: "😊",
    });
  };
  const onCloseClick = () => {
    setShowCabins(false);
    setUseEffect(true);
  };

  useEffect(() => {
    const ax_fetch = async () => {
      try {
        const ax = await ax_getCabins();
        console.log("ax_getCabins -> ", JSON.stringify(ax));
        if (ax.code === 200) {
          setUseEffect(true);
          setAllCabins(ax.data);
        }
      } catch (e) {
        console.log("Error while retriving Cabins from DB via Axios." + e);
      }
    };
    ax_fetch();
  }, [triggerUseEffect]);

  return (
    <section className={classes.Cabins} style={{ zIndex: -1 }}>
      <main className="Header" onClick={onCabinHeaderClick}>
        <section className="number">1</section>
        <section className="question_chevron">
          <div className="question">Choose a Cabin</div>
          <div className="text-sm text-gray-400 font-normal flex items-center justify-center">
            Click here{" "}
            <span className="hidden md:block ml-[6px]"> to view Cabins</span>
          </div>
          <div className="rightCon">
            <div className="selected ">
              Cabin:
              <span
              // className={`${
              //   cabinName === Cabins.cabin1
              //     ? classes.cabin1
              //     : cabinName === Cabins.cabin2
              //     ? classes.cabin2
              //     : cabinName === Cabins.cabin3
              //     ? classes.cabin3
              //     : classes.cabin4
              // }`}
              >
                {cabinName}
              </span>
            </div>
            {cabinName !== "" ? (
              <div className={classes.CheckIconCon}>
                <BsCheck className="icon" />
              </div>
            ) : (
              <div className={classes.EmptyCheckIconCon}>
                <BsCheck className="emptyIcon" />
              </div>
            )}

            {/* <div className="iconCon">
              <HiChevronDown
                style={{
                  transform: rotateCabinChev,
                  transition: "0.3s linear",
                }}
                className="icon"
              />
            </div> */}
          </div>
        </section>
      </main>
      {showCabins ? (
        <main className={Modal_Classes.Modal_Background}>
          <main className={Modal_Classes.Update_Import_Modal}>
            <section className={`Import_Modal_Container`}>
              <div className="update">Choose a Cabin</div>
              <div className="closeIconCon_Relative" onClick={onCloseClick}>
                <IoClose className="closeIcon_Relative" />
              </div>
              <main
                className={`${classes.Body} overflow-y-scroll ${
                  allCabins.length >= 4 ? `scrollbar-default` : `scrollbar-hide`
                }`}
              >
                <section className="BodyCon ">
                  {/* max-w-md px-4 mx-auto sm:px-7 md:max-w-4xl md:px-6 */}
                  {/* Cabin 1 */}
                  {/* {JSON.stringify(allCabins)} */}
                  {allCabins.length > 0 ? (
                    allCabins.map((cabin) => {
                      return (
                        <div>
                          <label
                            className={classes.Label}
                            htmlFor={cabin.cabinName}
                          >
                            <section
                              className={`${classes.Cabin_1} max-w-md px-4 mb-3 mx-auto sm:px-7 md:max-w-4xl md:px-6`}
                            >
                              <div className="Row1">
                                <div className="img">
                                  <img
                                    src={DyootiLogo}
                                    className="w-[40px] h-[40px] p-1 "
                                  />
                                </div>
                                <div className="Name_SeatingCapacity">
                                  <div className="name">{cabin.cabinName}</div>
                                  <div className="seatingCapacity">
                                    <span>Max. Capacity:</span>{" "}
                                    {cabin.maxCapacity}
                                  </div>
                                </div>
                              </div>
                              <div className="Row2 ">
                                <section className="location float-right hidden md:block">
                                  <div className="flex items-center justify-end">
                                    <span>{cabin.location.level},</span>
                                    <span>
                                      {cabin.location.buildingName},
                                    </span>{" "}
                                  </div>
                                  <div className="flex items-center justify-end -mt-[5px]">
                                    <span>{cabin.location.city},</span>
                                    <span>{cabin.location.state},</span>{" "}
                                    <span>{cabin.location.pincode},</span>
                                    <span>{cabin.location.country}</span>
                                  </div>
                                </section>
                                <section className="locationIcon  hidden md:block">
                                  <MdLocationOn className="h-7 w-7 " />
                                </section>
                              </div>
                            </section>
                          </label>
                          <input
                            id={cabin.cabinName}
                            name={cabin._id}
                            type={"radio"}
                            value={cabin.cabinName}
                            checked={cabinName === cabin.cabinName}
                            onChange={onChangeHandler}
                            className={classes.Cabin_1_input}
                            onClick={onSelectCabin}
                          />
                        </div>
                      );
                    })
                  ) : (
                    <div>No records found</div>
                  )}
                </section>
              </main>
            </section>
          </main>
        </main>
      ) : null}
    </section>
  );
};

export default CabinComponent;

/* <section className="BodyCon max-w-md px-4 mx-auto sm:px-7 md:max-w-4xl md:px-6">
          /* Cabin 1 */
/* <div>
          <label className={classes.Label} htmlFor={Cabins.cabin1}>
            <section
              className={`${
                cabinName === Cabins.cabin1
                  ? classes.Cabin_1_Active
                  : classes.Cabin_1
              } max-w-md px-4 mb-3 mx-auto sm:px-7 md:max-w-4xl md:px-6`}
            >
              <div className="Row1">
                <div className="img">
                  <img src={DyootiLogo} className="w-[40px] h-[40px] p-1 " />
                </div>
                <div className="Name_SeatingCapacity">
                  <div className="name">
                    <span>Cabin:</span>
                    {Cabins.cabin1}
                  </div>
                  <div className="seatingCapacity">
                    <span>maxCapacity:</span> 8
                  </div>
                </div>
              </div>
              <div className="Row2">
                <span>Total bookings:</span> 70
              </div>
            </section>
          </label>
          <input
            id={Cabins.cabin1}
            type={"radio"}
            value={Cabins.cabin1}
            checked={cabinName === Cabins.cabin1}
            onChange={onChangeHandler}
            className={classes.Cabin_1_input}
            onClick={slideNextToDate}
          />
        </div> */
/*
          <label className={classes.Label} htmlFor={Cabins.cabin4}>
            <section
              className={`${
                cabinName === Cabins.cabin4
                  ? classes.Cabin_4_Active
                  : classes.Cabin_4
              } max-w-md px-4 mb-3 mx-auto sm:px-7 md:max-w-4xl md:px-6`}
            >
              <div className="Row1">
                <div className="img">
                  <img src={tomImg} className="w-[40px] h-[40px]" />
                </div>
                <div className="Name_SeatingCapacity">
                  <div className="name">
                    <span>Cabin:</span>
                    {Cabins.cabin4}
                  </div>
                  <div className="seatingCapacity">
                    <span>maxCapacity:</span> 8
                  </div>
                </div>
              </div>
              <div className="Row2">
                <span>Total bookings:</span> 70
              </div>{" "}
            </section>
          </label>
          <input
            id={Cabins.cabin4}
            type={"radio"}
            value={Cabins.cabin4}
            checked={cabinName === Cabins.cabin4}
            onChange={onChangeHandler}
            className={classes.Cabin_4_input}
            onClick={slideNextToDate}
          />
        </div> */
/* Next Button */
/* {cabinName ? (
            <section
              className="flex items-center justify-end bg-primary w-fit p-2 rounded-md float-right"
              // onClick={slideNextToDate}
            >
              <div className="flex items-center justify-center">
                <BsCheckAll className="w-6 h-6" />
              </div>
              <div className="text-base font-medium px-1">Next</div>
            </section>
          ) : (
            <section
              className="flex items-center justify-end bg-grey w-fit p-2 rounded-md float-right"
              onClick={selectCabinPlease}
            >
              <div className="flex items-center justify-center">
                <BsCheckAll className="w-6 h-6" />
              </div>
              <div className="text-base font-medium px-1">Next</div>
            </section>
          )} 
        </section> */
